
define('modules/application/wizard/classes/kits/audioVideoKits',["app",

// Libs
"backbone",

//Classes
"../kits"],

function(app, Backbone, kits) {

  var intrusionDetectionKits = _.extend({}, kits, {

    Model: kits.Model.extend({
      defaults: _.extend({
        wizardChoiceId : 425
      }, kits.Model.defaults)
    })
  });

  // Required, return the module for AMD compliance
  return intrusionDetectionKits;
});